import { render } from "./MainNoticeModal.vue?vue&type=template&id=639dfdb0"
import script from "./MainNoticeModal.vue?vue&type=script&lang=js"
export * from "./MainNoticeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__